<template>
  <div class="app-container">
    <el-row>
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="left">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" style="width:340px" clearable placeholder="请输入标题" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="编号" prop="code">
          <el-input v-model="form.code" style="width:340px" clearable placeholder="请输入编号" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" style="width:340px" clearable placeholder="请输入排序" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="文章内容">
          <EDITOR v-model="form.content" :isClear="isClear"></EDITOR>
        </el-form-item>
        <div class="bottom">
          <el-button @click="confim(true)">发布</el-button>
          <el-button @click="confim(false)" :loading="confimLoading">保存</el-button>
        </div>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import editor from "@/components/editor";

export default {
  name: "byd-Article",
  components: { EDITOR: editor },
  data() {
    return {
      form: {
        title: "",
        content: "",
        code: "",
        sort: ""
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入编号",
            trigger: "blur"
          }
        ]
      },
      nodeId: "",
      articleId: null,
      confimLoading: false,
      isClear: false //清除富文本编辑器内容
    };
  },
  computed: {},
  methods: {
    confim(isPubsish) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confimLoading = true;
          var params = {
            title: this.form.title,
            content: this.form.content,
            code: this.form.code,
            isPublish: isPubsish
          };
          if (this.articleId != null) {
            params.articleId = Number(this.articleId);
            params.sort = Number(this.form.sort);
          } else {
            params.nodeId = this.nodeId;
          }
          this.$httpAuth
            .post(
              this.articleId != null
                ? "/v1/backendHelpRpc/updateArticle"
                : "/v1/backendHelpRpc/addArticle",
              params
            )
            .then(res => {
              this.confimLoading = false;
              this.$message({
                message: isPubsish ? "发布文章成功" : "编辑文章成功",
                type: "success"
              });
              this.$store.dispatch("delCurrentView");
              this.$router.push("/help/bydIndex");
            })
            .catch(() => {
              this.confimLoading = false;
            });
        }
      });
    },
    cancel() {
      this.$router.go(-1);
    },
    getArticle() {
      this.$httpAuth
        .post("/v1/backendHelpRpc/getArticle", {
          articleId: this.articleId
        })
        .then(res => {
          var data = res.data.data;
          this.form = {
            code: data.code,
            content: data.content,
            sort: data.sort,
            title: data.title
          };
        });
    }
  },
  created() {
    if (this.$route.query.nodeId) {
      this.nodeId = Number(this.$route.query.nodeId);
    }
    if (this.$route.query.articleId) {
      this.articleId = Number(this.$route.query.articleId);
      this.getArticle();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.form.resetFields();
    });
  }
};
</script>
<style  scoped>
.bottom {
  padding-left: 100px;
  box-sizing: border-box;
}
</style>
<style>
body {
  overflow: visible !important;
}

.w-e-toolbar {
  z-index: 2 !important;
}

.w-e-text-container {
  z-index: 1 !important;
  height: 600px !important;
}

.w-e-full-screen-editor .w-e-text-container {
  height: calc(100% - 42px) !important;
}
</style>
